// extracted by mini-css-extract-plugin
export default {"block":"tj","info":"uj","error":"vj","noSpace":"wj","optional":"xj"};